import { defaults } from 'lodash';
import React from 'react';
import Currency from '../currency';
import { useUser } from '../user_hooks';
import { RCTextInput, TextInputProps } from '@reverbdotcom/cadence/components';

interface Props extends TextInputProps {
  /** Currency for value */
  currencyCode: string;
}

const NUMERIC_PATTERN = '[0-9.,\\s]*';

export function MoneyInput({ currencyCode, ...props }: Props) {
  const { symbol } = defaults(Currency.get(currencyCode), { symbol: '' });
  const { locale, countryCode } = useUser();

  function suffixText() {
    if (locale === 'en' && countryCode === 'US' && currencyCode === 'USD') {
      return props.suffixText;
    }

    return [currencyCode, props.suffixText].join(' ').trim();
  }

  return (
    <RCTextInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      prefixText={symbol}
      suffixText={suffixText()}
      type="text"
      pattern={NUMERIC_PATTERN}
      inputMode="decimal"
    />
  );
}
